import {ListIndex} from './classes/lists_index.js';
import {Modal} from '../weave/modal.mjs';
import * as Helper from '../weave/helpers.mjs';
// import '../main.mjs';

let $dataTable = $('#dataTable');
new ListIndex($dataTable, {
    actions: {
        delete: new Helper.EntityAction({
            route: '/savedSearch/delete',
            loadingMessage: 'Deleting...',
        }),
        edit: new Helper.EntityAction({
            custom: 'editAction'
        })
    },
    jsPagination: false,
    indexRoute: '/productList/indexList'
});

let modals = document.querySelectorAll('dialog');
if(modals != null){
    Array.prototype.forEach.call(modals, function(element, index){
        new Modal(element.id);
    });
}